// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"94":"RelaysNav","95":"MapSingle","316":"MapSummary","429":"JobQueue","539":"DetailLog","621":"DetailHeader","776":"RelaysResultTable"}[chunkId] + "." + {"94":"c2dbda74","95":"a9601ca7","316":"e4e4fb57","429":"d4211225","539":"95768c3a","621":"22187a43","776":"eb2b1728"}[chunkId] + ".css";
};